import React from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import FormGroup from '../helpers/FormGroup'

class Final extends React.Component {
  constructor(props) {
    super(props)
  }

  validate() {
    //
  }

  render() {
    const values = this.props.data
    const setData = this.props.setData
    console.log(values.news_signup)

    return(
     <fieldset className="fieldset">
        <legend className="h2">Almost there! Just one more thing.</legend>
        <div className="row">
          <div className="col-12">
            <div className="form-group form-check">
              <label htmlFor="news_signup" className="form-check-label">
                Keep me in the loop about Canaan news, programs and events.
              </label>
              <input
                type="checkbox"
                className="form-check-input"
                checked={values.news_signup}
                style={{'marginTop': '0'}}
                onChange={(e) => setData({news_signup: e.target.checked})}
              />
              <p className="hint"><small>We won't spam you.</small></p>
            </div>
          </div>
        </div>
      </fieldset>
    )
  }
}

export default Final